import { createFileRoute, Outlet } from '@tanstack/react-router';
import { Header } from "@/components/homepage/Header";
import { Footer } from "@/components/homepage/Footer";
import { ContentSidebar } from "@/components/marketing/ContentSidebar";

export const Route = createFileRoute('/features')({
  component: FeaturesLayout,
});

const featuresSidebar = {
  title: "Features",
  sections: [
    {
      items: [
        { label: "Overview", href: "/features" },
      ]
    },
    {
      title: "Core Platform",
      items: [
        { label: "2000+ Integrations", href: "/features/integrations", iconName: "Puzzle" },
        { label: "Enterprise Security", href: "/features/security", iconName: "Shield" },
        { label: "AI/LLM Gateway", href: "/features/ai-gateway", iconName: "BrainCircuit" },
      ]
    },
    {
      title: "Automation",
      items: [
        { label: "Workflow Builder", href: "/features/workflow-engine", iconName: "Workflow" },
        { label: "AI Agents Platform", href: "/features/agents-platform", iconName: "Bot" },
      ]
    },
    {
      title: "Enterprise",
      items: [
        { label: "Real-time Analytics", href: "/features/analytics", iconName: "BarChart3" },
        { label: "SSO & SAML", href: "/features/sso-saml", iconName: "Key" },
      ]
    }
  ]
};

function FeaturesLayout() {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <div className="container px-6 py-12">
        <div className="flex gap-12">
          <ContentSidebar
            title={featuresSidebar.title}
            sections={featuresSidebar.sections}
          />
          <main className="flex-1 min-w-0">
            <Outlet />
          </main>
        </div>
      </div>
      <Footer />
    </div>
  );
}
